import React from 'react';

import ShrinkIcon from '@images/IconHeader/shrink.svg';
import { Action, ActionProps } from './Action';

export function Shrink( props: ActionProps ) {
  return (
    <Action
      {...props}
      active={{
        fill: 'rgba(255, 70, 70, 0.95)',
        background: 'rgba(255, 70, 70, 0.1)',
      }}
    >
      <ShrinkIcon/>
    </Action>
  );
}
